
$(document).ready(function () {
    if (!$(".js-navigation-bar .barAnchorNavLink").length) return;

    $(".js-navigation-bar .barAnchorNavLink").click(function (e) {
        e.preventDefault();
        const totalStickyHeight = $('.header-main').outerHeight() + $(".js-navigation-bar").outerHeight();
        $('html, body').animate({
            scrollTop: Math.ceil($($(this).data('target')).offset().top - totalStickyHeight)
        }, 500);
    });

    $(window).scroll(function () {
        const totalStickyHeight = $('header').outerHeight() + $(".js-navigation-bar").outerHeight();
        const check = $(this).scrollTop() + totalStickyHeight;
        let found = false;
        $(".barAnchorContent").each(function () {
            const content = $(this);
            const nav = $(".barAnchorNavLink[data-target='#" + this.id + "']");
            const top = Math.floor(content.offset().top);
            if (!found && top - 1 <= check && top + content.outerHeight() > check) {
                if (!nav.hasClass("active")) {
                    nav.addClass("active");
                }
                found = true;
            } else {
                nav.removeClass("active");
            }
        });
    });
});